import { render, staticRenderFns } from "./ExamSingleChoice.vue?vue&type=template&id=7fffb068&"
import script from "./ExamSingleChoice.vue?vue&type=script&lang=js&"
export * from "./ExamSingleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports